import { render, staticRenderFns } from "./YardAttachmentsTable.vue?vue&type=template&id=2ceea4be&"
import script from "./YardAttachmentsTable.vue?vue&type=script&lang=js&"
export * from "./YardAttachmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports